/* Package JSON Import will be here */
import React, { useEffect } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector } from "react-redux";
import { Modal, Button, Typography } from "antd";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
/* Package JSON Import will be here */

/* Project Import will be here */
import { errorToast } from 'utilities/utils';
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
/* Const,Let & Var will be here */

const VoiceSearchModal = (props) => {
    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition();

    const startListening = () => SpeechRecognition.startListening({ continuous: true });

    const { translate } = useSelector((state) => ({
        translate: getTranslate(state.locale)
    }));

    const onSubmitVoiceSearch = () => {
        props.onSubmitVoiceCallBack(transcript);
        props.cancelVoiceSearch();
    }

    useEffect(() => {
        /* Check for browser support */
        if (!browserSupportsSpeechRecognition) {
            errorToast({ content: translate("common.alerts.error.browserVoiceSearchNotSupport") });
            props.cancelVoiceSearch();
        }
    }, []);

    /* Check for browser support */
    if (!browserSupportsSpeechRecognition) {
        return null;
    }

    return (
        <React.Fragment>
            <Modal
                onCancel={props.cancelVoiceSearch}
                width={500}
                centered
                maskClosable={false}
                visible={props.isShowVoiceSearchModal}
                className="voice-search-modal"
                closeIcon={<i className="fa fa-times-circle fa-lg" aria-hidden="true"></i>}
                footer={[
                    <Button size="large" disabled={listening || transcript === ""} key="reset" onClick={() => resetTranscript()}>
                        {translate("common.buttons.clear")}
                    </Button>,
                    <Button size="large" disabled={listening} key="cancel" onClick={props.cancelVoiceSearch}>
                        {translate("common.buttons.cancel")}
                    </Button>,
                    <Button size="large" disabled={listening || transcript === ""} key="ok" type="primary" onClick={onSubmitVoiceSearch}>
                        {translate("common.buttons.search")}
                    </Button>
                ]}
            >
                <React.Fragment>
                    <div className="text-center p-2">
                        <div className="voice-search-btn">
                            <Button
                                type="primary"
                                shape="circle"
                                icon={<i className="fa fa-microphone voice-big-icon" aria-hidden="true"></i>}
                                onTouchStart={startListening}
                                onMouseDown={startListening}
                                onTouchEnd={SpeechRecognition.stopListening}
                                onMouseUp={SpeechRecognition.stopListening}
                            />
                        </div>

                        <div className="p-1">
                            {listening ? translate("common.buttons.listening") : translate("common.buttons.pressAndHold")}
                        </div>
                    </div>

                    {transcript !== "" &&
                        <div className="text-center p-1">
                            <Text mark>
                                {transcript}
                            </Text>
                        </div>
                    }

                    <div className="pt-3">
                        <Text className="font-12" type="warning">{translate("common.header.search.microPhoneAccessNote")}</Text>
                    </div>
                </React.Fragment>
            </Modal>
        </React.Fragment>
    );
};

export default VoiceSearchModal;